"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Access = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _registrar = _interopRequireDefault(require("./compiler/registrar"));

var _accessControl = _interopRequireDefault(require("./access-control"));

var _each = _interopRequireDefault(require("lodash/each"));

// Note: this function contains client-specific access control logic
var Access = /*#__PURE__*/function () {
  function Access() {
    (0, _classCallCheck2.default)(this, Access);
    this._accessControl = new _accessControl.default(); // For mocking

    this._registrar = _registrar.default;
  }

  (0, _createClass2.default)(Access, [{
    key: "canAccess",
    value: function canAccess(operation, form) {
      var access = form.get('access');

      if (access && access.form && access.form[operation]) {
        var opRoles = access.form[operation];
        var roles = Array.isArray(opRoles) ? opRoles : [opRoles];
        return this._registrar.client.user.hasRole(roles);
      } else {
        // No roles specified so can access
        return true;
      }
    }
  }, {
    key: "canCreate",
    value: function canCreate(form) {
      return this.canAccess('create', form);
    }
  }, {
    key: "canRead",
    value: function canRead(form) {
      return this.canAccess('read', form);
    }
  }, {
    key: "canUpdate",
    value: function canUpdate(form) {
      return this.canAccess('update', form);
    }
  }, {
    key: "canArchive",
    value: function canArchive(form) {
      return this.canAccess('archive', form);
    }
  }, {
    key: "_fieldsOrValuesCanAccess",
    value: function _fieldsOrValuesCanAccess(operation, form, getOpts, forFields, canDowngrade) {
      var access = form.get('access');

      var session = this._registrar.client && this._registrar.client.user.getSession();

      var indexedRoles = {};
      var isOwner = false;

      if (session && session.user.roles) {
        (0, _each.default)(session.user.roles, function (role, id) {
          // The client uses the role name to check access
          indexedRoles[role.name] = true;
        });
        isOwner = session.user.id === form.getValue('userId');
      }

      var fieldValues = form.getValues(getOpts);
      var canAccessName = forFields ? 'fieldsCanAccess' : 'valuesCanAccess';
      return this._accessControl[canAccessName](operation, access, indexedRoles, fieldValues, isOwner, canDowngrade);
    }
  }, {
    key: "fieldsCanAccess",
    value: function fieldsCanAccess(operation, form, getOpts, canDowngrade) {
      return this._fieldsOrValuesCanAccess(operation, form, getOpts, true, canDowngrade);
    }
  }, {
    key: "fieldsCanCreate",
    value: function fieldsCanCreate(form) {
      return this.fieldsCanAccess('create', form, {
        out: true
      });
    }
  }, {
    key: "fieldsCanRead",
    value: function fieldsCanRead(form) {
      return this.fieldsCanAccess('read', form);
    }
  }, {
    key: "fieldsCanUpdate",
    value: function fieldsCanUpdate(form) {
      return this.fieldsCanAccess('update', form, {
        out: true
      });
    }
  }, {
    key: "valuesCanAccess",
    value: function valuesCanAccess(operation, form, getOpts) {
      return this._fieldsOrValuesCanAccess(operation, form, getOpts, false);
    }
  }, {
    key: "valuesCanCreate",
    value: function valuesCanCreate(form, opts) {
      return this.valuesCanAccess('create', form, Object.assign({
        out: true
      }, opts));
    }
  }, {
    key: "valuesCanRead",
    value: function valuesCanRead(form, opts) {
      return this.valuesCanAccess('read', form, opts);
    }
  }, {
    key: "valuesCanUpdate",
    value: function valuesCanUpdate(form, opts) {
      return this.valuesCanAccess('update', form, Object.assign({
        out: true
      }, opts));
    }
  }]);
  return Access;
}();

exports.Access = Access;

var _default = new Access();

exports.default = _default;